import {  ToolTye } from '@/components/Note/utils';
import React, { ReactNode, useMemo } from 'react';
import { useIntl } from 'umi';
import s from './index.less';
import Icon from '@/components/Icon';
import classNames from 'classnames';

export type SelectBoxValue = {
  topTitle:string,
  TopComponent:ReactNode,
  bottomTitle:string,
  BottomComponent:ReactNode
}

const SelectBox: React.FC<SelectBoxValue> = (props) => {
  const { topTitle,TopComponent,bottomTitle,BottomComponent } = props;

  return (
    <div className={s.container}>
      <div className={s.row}>
        <span className={s.title}>{topTitle}</span>
        <div className={s.list}>
          {TopComponent}
        </div>
        <div className={s.split}></div>
      </div>
      <div className={s.row}>
        <span className={s.title}>{bottomTitle}</span>
        <div className={s.list}>
          {BottomComponent}
        </div>
      </div>
    </div>
  );
};

export default SelectBox;
